import React,{ useState,useRef, useEffect} from "react";
import styled from "styled-components";
import {showAlert} from "../../../globals/Message";
import { Row, Col, Container } from 'react-bootstrap';
import Button from "../../../globals/Button";
import {Formulario} from "../../../globals/dhtmlx/Form";
import FormErrorMessage from "../../../globals/FormErrorMessage";
import ReCAPTCHA from 'react-google-recaptcha';
import { apiCall } from "../../../../helpers/ApiCalls";
import { useHistory,useParams } from "react-router-dom";
import Loader from "../../../globals/Loader";

const recaptcha_key = process.env.REACT_APP_RECAPTCHA;

const Wrapper = styled(Container)`
  display:grid;
  justify-content:center;
  align-items:center;
`;
const HeaderContianer = styled(Row)`
  display:grid;
  margin:0;
  padding:32px 0 16px ;
  justify-content:center;
  align-items:center;
`;
const H1 = styled.h1`
  display: flex;
  justify-content: center;
  font-size: 32px  
`;
const BodyContianer = styled(Row)`
  display:grid;
  margin:0;
  padding:16px 24px;
  justify-content:center;
  align-items:center;
  max-width:360px;
  background:#F0F0F0;
  border: 1px solid #EDEDED;
  border-radius: 5px
`;
const MessageContianer = styled(Row)`
  display:flex;
  margin:16px 0;
  padding:16px 24px;
  justify-content:center;
  align-items:center;
  max-width:360px;
  background-color: #FFEBE9;
  border: 1px solid #FFC1C0;
  border-radius: 5px
`;
const CaptchaContianer = styled.div`
  display:flex;
  justify-content:center;
  margin-top:-16px;
  margin-bottom:16px;
`
function FormUpdate (props){
  const urlParams = useParams();
  let history = useHistory();

  const [ready, setReady] = useState(false);
  const [inputs, setInputs] = useState({});
  const [valid, setValid] = useState(false);
  const [captchaValido, setCaptchaValido] = useState(process.env.REACT_APP_ENTORNO ==='Dev'?true:false);
  const captcha = useRef(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  
  function changeCaptcha (){
    if(captcha.current.getValue()){
      setCaptchaValido(true);
    }
    else{
      setCaptchaValido(false);

    }
  }

  function toggleInput(value){
    setInputs(value);
  }
  useEffect(()=>{
    const params = {
     token: urlParams.token
    }
    apiCall('POST','reset_password/verify',params).then((res)=>{
      if(res.success){
        setReady(true);
      }
      else{
        showAlert("El token caduco o es invalido",()=>{
          history.push('/');
        });
          return true;
      }
    });
  },[]);
  async function actualizarPassword(){
    setButtonLoading(true);
    if(captchaValido && valid && Object.keys(inputs).length >0){
      if(inputs.password === inputs.password_verify){
        //hacemos la llamada a la API de
        setShowMessage(false);
        let params = {
          token: urlParams.token,
          password:inputs.password
        }
        await apiCall('PUT','reset_password/update',params).then((res)=>{
          if(res.success && res.code === 200){
            showAlert("Tu contraseña se a actualizado con exito. Puedes ingresar ahora",()=>{
              history.push('/');
            });
            return true;
          
          }
          setMessage("Ocurrio un error por favor intenta más tarde");
          setShowMessage(true);
          setButtonLoading(false);

          return true;
        });
      }
      else{
        setMessage("Las contraseñas no coinciden, por favor verifica que sean correctas.");
        setShowMessage(true);
        setButtonLoading(false);
      }
     
      
    }else{
      if(!captchaValido){
        setMessage("Por favor valida tu identidad");
        setShowMessage(true);
      }
      setButtonLoading(false);
    }
    
  }
  const rows = [
    {
      id: "password",
      type: "input",
      inputType: "password",
      label:"Contraseña Nueva:",
      placeholder: "Ingresa tu contraseña nueva",
      preMessage: "",
      errorMessage: "Contraseña invalida",
      successMessage: "Contraseña valido",
      required: true,
      css:"fondo-transparente",
    } ,
    {
      id: "password_verify",
      type: "input",
      inputType: "password",
      label:"Verifica tu Contraseña nueva:",
      placeholder: "Ingresa tu contraseña nueva",
      preMessage: "",
      errorMessage: "Contraseña invalida",
      successMessage: "Contraseña valido",
      required: true,
      css:"fondo-transparente",
    
    }  
  ];
  if(ready){
    return (
      <Wrapper id="wrapper_contianer">
        <HeaderContianer id="header_container">
          <div style={{display:'flex',justifyContent:'center',alignItems:'center', margin:'0 24px 8px 0'}}>
            <img src="../gp.png" alt="_logo"></img>
          </div>
          <H1>Actualizar Contraseña</H1>
        </HeaderContianer>
        <BodyContianer>
          <span style={{textAlign:'justify'}}>
              Ingresa una nueva contraseña para poder acceder a MarketPlace. <br></br>
              <ul style={{margin:'0'}}>
                <li>Minimo de 8 caracteres</li>
              </ul>
          </span>
          <Formulario
            rows={rows}
            padding = {0}
            width = {'100%'}
            toggleInputs = {toggleInput}
            toggleValid = {setValid}
            toogleMessage = {setShowMessage}
            loading = {buttonLoading}
            css={"fondo-transparente"}
          />
          <CaptchaContianer id="google_recaptcha">
            { process.env.REACT_APP_ENTORNO ==='Dccev'?(<></>):(<ReCAPTCHA
              ref={captcha}
              sitekey={recaptcha_key}
              onChange={changeCaptcha}
            />)}
          </CaptchaContianer>
          <Button width={'60%'} flat = {true} onClick={actualizarPassword} loading={buttonLoading}>Actualizar</Button>
        </BodyContianer>
        <FormErrorMessage
          showMessage={showMessage}
          message={message}
          toggleMessage = {setShowMessage}
          width={'360px'}
        />
      </Wrapper>
    );
  }
  return (
    <div id="wrapper_contianer" style={{height:'100vh', display:'flex',justifyContent:'center',alignItems:'center'}}>
      <Loader/>
    </div>

  );
}
export default FormUpdate;